import {
    CRM_LIST_PAGE_ROUTE,
    CRM_LIST_PAGE_ROUTE_URL,
    SI_ROOT_ROUTE,
    STATIC_LIST_PAGE_ROUTE,
    STATIC_LIST_PAGE_ROUTE_URL,
} from "app/pages/sales-intelligence/constants/routes";
import { EmailTrackingEntityType } from "app/pages/sales-intelligence/services/enums";
import emailTrackingService, {
    type PageViewTrackingParams,
} from "app/pages/sales-intelligence/services/tracking/emailTrackingService";
import {
    crmListRoutingParams,
    staticListRoutingParams,
} from "app/pages/sales-intelligence/sub-modules/opportunities/constants/routing-params";
import { signalsRoutingParams } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import { SwTrack } from "app/services/SwTrack";
import { markPageViewIntentionallySkipped } from "app/services/track/pageViewTrackSignal";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

import CrmListPageRootContainer from "../containers/PageRootContainer/CrmListPageRootContainer";
import StaticListPageRootContainer from "../containers/PageRootContainer/StaticListPageRootContainer";

import { onEnterListPage } from "./route-hooks";

export const OPPORTUNITY_LIST_STATE_CONFIG: Record<string, IRouterState> = {
    [STATIC_LIST_PAGE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: STATIC_LIST_PAGE_ROUTE_URL,
        onEnter: onEnterListPage,
        component() {
            return (
                <div className="sw-layout-scrollable-element use-sticky-css-rendering">
                    <StaticListPageRootContainer />
                </div>
            );
        },
        configId: "SalesWorkspace",
        configIdDeps: ["WsCustomMetrics", "LeadGenerationReport"],
        stateNameForEductionBar: "salesIntelligence-myLists-staticList",
        stateId: "salesIntelligence-myLists-staticList",
        pageTitle: "si.pages.my_lists.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceLists",
        pageId: {
            section: "target accounts",
            subSection: "static list",
            subSubSection: "static list sites",
        },
        params: { ...signalsRoutingParams, ...staticListRoutingParams },
        trackingId: (params?: { isRecent?: string }) => {
            const isRecentlyViewedOpportunityList = params?.isRecent === "true";

            return {
                section: "target accounts",
                subSection: isRecentlyViewedOpportunityList ? "recently viewed static list" : "static list",
                subSubSection: isRecentlyViewedOpportunityList
                    ? "recently viewed static list sites"
                    : "static list sites",
            };
        },
        data: {
            pageViewTracking: function ({ toParams, toState }: PageViewTrackingParams) {
                emailTrackingService.trackSignalsDigestEmail(EmailTrackingEntityType.STATIC_LIST, toParams);

                if (!toParams.signalId) {
                    SwTrack.trackPageView(toState, toParams);
                } else {
                    markPageViewIntentionallySkipped();
                }
            },
        },
    },
    [CRM_LIST_PAGE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: CRM_LIST_PAGE_ROUTE_URL,
        onEnter: onEnterListPage,
        component() {
            return (
                <div className="sw-layout-scrollable-element use-sticky-css-rendering">
                    <CrmListPageRootContainer />
                </div>
            );
        },
        configId: "SalesWorkspace",
        configIdDeps: ["WsCustomMetrics", "LeadGenerationReport"],
        data: {
            pageViewTracking: function ({ toParams, toState }: PageViewTrackingParams) {
                emailTrackingService.trackSignalsDigestEmail(EmailTrackingEntityType.CRM_STATIC_LIST, toParams);

                if (!toParams.signalId) {
                    SwTrack.trackPageView(toState, toParams);
                } else {
                    markPageViewIntentionallySkipped();
                }
            },
        },
        pageId: {
            section: "target accounts",
            subSection: "crm static list",
            subSubSection: "crm static list sites",
        },
        params: { ...signalsRoutingParams, ...crmListRoutingParams },
        pageTitle: "si.pages.crm_lists.document_title",
        stateNameForEductionBar: "salesIntelligence-myLists-crmList",
        stateId: "salesIntelligence-myLists-crmList",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceLists",
        trackingId: {
            section: "target accounts",
            subSection: "crm static list",
            subSubSection: "crm static list sites",
        },
    },
};
